import React from 'react';
import './InfoPage.css';

function HostResources() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Recursos para Anfitriões</h1>

        <section className="info-section">
          <h2>Tudo que você precisa para ter sucesso como anfitrião</h2>
          <p>Acesse guias, ferramentas e recursos projetados para ajudá-lo a criar uma experiência excepcional de hospedagem e maximizar seus ganhos.</p>
        </section>

        <section className="info-section">
          <h3>Guias para Começar</h3>
          <div className="feature-grid">
            <div className="feature-box">
              <h4>Guia de Fotografia</h4>
              <p>Aprenda a tirar fotos deslumbrantes que atraem mais hóspedes. Dicas sobre iluminação, ângulos e como destacar suas melhores características.</p>
            </div>
            <div className="feature-box">
              <h4>Escrevendo Seu Anúncio</h4>
              <p>Crie descrições atraentes que destacam o que torna seu espaço especial e definem expectativas precisas dos hóspedes.</p>
            </div>
            <div className="feature-box">
              <h4>Estratégia de Preços</h4>
              <p>Otimize seus preços para se manter competitivo enquanto maximiza seus ganhos. Aprenda sobre ajustes sazonais e promoções.</p>
            </div>
            <div className="feature-box">
              <h4>Gerenciamento de Calendário</h4>
              <p>Domine suas configurações de disponibilidade, estadias mínimas e tempo de preparação entre reservas.</p>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Ferramentas para Anfitriões</h3>

          <div className="feature-box">
            <h4>Painel de Desempenho</h4>
            <p>Acompanhe o desempenho do seu anúncio com insights sobre visualizações, taxas de reserva e receita. Compare seu anúncio com propriedades semelhantes em sua área.</p>
          </div>

          <div className="feature-box">
            <h4>Mensagens Inteligentes</h4>
            <p>Use modelos de mensagens e respostas automatizadas para se comunicar eficientemente com os hóspedes mantendo um toque pessoal.</p>
          </div>

          <div className="feature-box">
            <h4>Aplicativo Mobile</h4>
            <p>Gerencie seu anúncio em qualquer lugar. Responda aos hóspedes, atualize seu calendário e acompanhe ganhos de qualquer lugar.</p>
          </div>

          <div className="feature-box">
            <h4>Configurações de Notificação</h4>
            <p>Personalize como e quando você recebe atualizações sobre reservas, mensagens e avaliações.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Excelência em Hospitalidade</h3>

          <div className="help-topic">
            <h4>Check-in e Check-out</h4>
            <ul>
              <li>Melhores práticas para chegadas e partidas sem problemas</li>
              <li>Criação de um guia digital para sua propriedade</li>
              <li>Opções de check-in autônomo e fechaduras inteligentes</li>
              <li>Políticas de check-in antecipado e check-out tardio</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Comunicação com Hóspedes</h4>
            <ul>
              <li>Melhores práticas de tempo de resposta</li>
              <li>Definição de regras claras da casa</li>
              <li>Tratamento de solicitações especiais</li>
              <li>Gerenciamento de situações difíceis profissionalmente</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Comodidades e Extras</h4>
            <ul>
              <li>Comodidades essenciais que todo anúncio deve ter</li>
              <li>Comodidades premium que comandam preços mais altos</li>
              <li>Presentes de boas-vindas e recomendações locais</li>
              <li>Manutenção e atualização do seu espaço</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Recursos Legais e Financeiros</h3>

          <div className="feature-box">
            <h4>Informações Fiscais</h4>
            <p>Entenda suas obrigações fiscais como anfitrião. Acesse formulários fiscais, diretrizes de relatórios e recursos para diferentes países.</p>
          </div>

          <div className="feature-box">
            <h4>Regulamentações Locais</h4>
            <p>Mantenha-se em conformidade com leis locais de aluguel de curto prazo, licenças e regulamentações em sua área.</p>
          </div>

          <div className="feature-box">
            <h4>Processamento de Pagamentos</h4>
            <p>Aprenda sobre métodos de pagamento, timing e gerenciamento de seus ganhos. Configure depósito direto ou outras preferências de pagamento.</p>
          </div>

          <div className="feature-box">
            <h4>Seguro e Proteção</h4>
            <p>Entenda suas opções de cobertura, proteção contra danos ao anfitrião e seguro de responsabilidade incluído em cada reserva.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Hospedagem Profissional</h3>
          <ul>
            <li><strong>Gerenciamento de Propriedades:</strong> Dicas para anfitriões gerenciando múltiplas propriedades</li>
            <li><strong>Co-hospedagem:</strong> Aprenda a trabalhar com co-anfitriões para compartilhar responsabilidades</li>
            <li><strong>Serviços de Limpeza:</strong> Encontrar e gerenciar limpadores profissionais</li>
            <li><strong>Preços Dinâmicos:</strong> Estratégias avançadas para maximizar receita</li>
            <li><strong>Marketing do Seu Anúncio:</strong> Promover seu espaço além da plataforma</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Tutoriais em Vídeo</h3>
          <p>Assista guias em vídeo passo a passo cobrindo tudo desde criar seu primeiro anúncio até estratégias avançadas de hospedagem:</p>
          <ul>
            <li>Configurando Seu Primeiro Anúncio (5 min)</li>
            <li>Otimizando Suas Fotos (8 min)</li>
            <li>Precificação para o Sucesso (12 min)</li>
            <li>Melhores Práticas de Comunicação com Hóspedes (10 min)</li>
            <li>Lidando com Avaliações e Classificações (7 min)</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Precisa de Mais Ajuda?</h3>
          <p>Não encontrou o que procura? Visite nossa Central de Ajuda ou entre em contato com nossa equipe de Suporte ao Anfitrião 24/7.</p>
        </section>
      </div>
    </div>
  );
}

export default HostResources;
